<template>

<form id="serviceTypeForm" class="mx-auto col-sm-8" @submit.prevent>

  <div class="row">
    <div class="form-group col-lg-12" :class="{ 'has-error': errors.has('name') }">
      <label for="name">{{ $t('name') }}</label>
      <input
        :disabled='(this.$route.params.id && this.$route.params.id >= 1 && this.$route.params.id <= 6 )'
        type="text"
        id="name"
        name="name"
        class="form-control"
        :placeholder="$t('type_name')"
        v-model="serviceType.name"
        v-validate="'required'"
      >
      <small v-show="errors.has('name')" class="form-text text-muted">
        {{ errors.first('name') }}
      </small>
    </div>

    <div class="switch col-lg-12 mb-3">
      <label for="active">{{ $t('active') }}</label>
      <div class="onoffswitch2">
        <input
          type="checkbox"
          class="onoffswitch2-checkbox"
          id="active"
          v-model="serviceType.isActive">
        <label class="onoffswitch2-label" for="active">
            <span class="onoffswitch2-inner"></span>
            <span class="onoffswitch2-switch"></span>
        </label>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton @click="onClick">
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div> 

</form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'

export default {
  name: 'ServiceTypeForm',
  components: {
    LoaderButton
  },
  props: {
    serviceType: {
      type: Object,
      default: () => ({
        id: undefined,
        name: '',
        isActive: true,
      })
    }
  },
  methods: {
    ...mapActions('servicetypes', [
      'create',
      'edit',
      'cleanState'
    ]),

    async onClick (evtClick, doneFn) {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }

      const { id } = this.serviceType

      const promise = id 
        ? this.edit({ id, data: this.serviceType })
        : this.create(this.serviceType)

      const result = await promise

      if (result) this.$router.push({ name: 'listservicetypes' })
    }
  },

  destroyed () {
    this.cleanState()
  }
}
</script>